/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NonLabExamDetailAliases {
  ACTION_IMAGES = 'action-images',
  CONTEXTUALBAR_ACTIONS = 'contextualbar-actions',
  FETCH_NON_LAB_EXAM_DETAIL = 'fetch-non-lab-exam-detail',
  FIELD_DS_TITULO_LAUDO = 'field-ds-titulo-laudo',
  FIELD_DT_EXAME = 'field-dt-exame',
  FIELD_DT_LAUDO = 'field-dt-laudo',
  FIELD_NM_MEDICO_RESP = 'field-nm-medico-resp',
  FIELD_NR_ATENDIMENTO = 'field-nr-atendimento',
  FIELD_STATUS_LAUDO = 'field-status-laudo',
  FORM_NON_LAB_EXAM_DETAIL = 'form-non-lab-exam-detail',
  IMAGE_VIEWER_BUTTON = 'image-viewer-button',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_NON_LAB_EXAM_DETAIL = 'layout-non-lab-exam-detail',
  LOADER = 'loader',
  MEDIA_CONTAINER_NON_LAB = 'media-container-non-lab',
  PAC_BTN = 'pac-btn',
  PANEL_LOADER = 'panel-loader',
  PANEL_MEDIA_CONTAINER_PDF_VIEWER = 'panel-media-container-pdf-viewer',
  PANEL_NON_LAB_EXAM_DETAIL = 'panel-non-lab-exam-detail',
  PANEL_PDF_VIEWER_EXAM_DETAILS = 'panel-pdf-viewer-exam-details',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  TEXT_DS_TITULO_LAUDO = 'text-ds-titulo-laudo',
  TEXT_DT_EXAME = 'text-dt-exame',
  TEXT_DT_LAUDO = 'text-dt-laudo',
  TEXT_NM_MEDICO_RESP = 'text-nm-medico-resp',
  TEXT_NR_ATEMDIMENTO = 'text-nr-atemdimento',
  TEXT_STATUS_LAUDO = 'text-status-laudo',
}
export { NonLabExamDetailAliases };
